var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.commercialPrint.actionsAvailable)?_c('router-link',{attrs:{"to":{ name: 'commercial-print-single', params: { id: _vm.commercialPrint.id } }}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" mdi-bell-ring ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }